import {TrucksFilters} from './../model/trucks';
import {Http, RequestOptions, Response,} from '@angular/http';
import {throwError as observableThrowError} from 'rxjs';
import {AuthHeaderService} from '../views/authheader.service';
import {environment} from '../../environments/environment';
import {Injectable} from '@angular/core';
import {catchError, map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TrucksService {
  trucksurl: string;
  uploadFileUrl: string;
  trucksAvailurl: string;

  constructor(private http: Http, private _headerService: AuthHeaderService) {
    this.trucksurl = environment.trucksurl;
    this.uploadFileUrl = environment.uploadUrl;
    this.trucksAvailurl = environment.trucksAvailurl;
  }

  SendForm(pageFilters: TrucksFilters) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.trucksurl, pageFilters, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getTrucksData() {
    // console.log(this.trucksurl);
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.trucksurl, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getTrucksAvailData(st) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    let url = this.trucksAvailurl;
    url = url + (st ? `?fromDate=${st}` : '');
    return this.http.get(url, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );

  }

  EditTrucks(obj, id) {
    delete obj['_id'];
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    // console.log(this.trucksurl + "/" + id);
    // console.log(JSON.stringify(obj));
    return this.http.put(this.trucksurl + '/' + id, obj, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  DeleteTrucks(_id) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    // console.log(this.trucksurl + "/" + _id);
    return this.http.delete(this.trucksurl + '/' + _id, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  uploadFile(file) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.uploadFileUrl, file, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  downloadFile() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.uploadFileUrl, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getTruckTypesData() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(environment.truckTypesUrl, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getTruckLastLocation() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(environment.trucksurl + '/trucksWithLastLocation', options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  trackTruckByLoad(loadId: string) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(environment.trucksurl + `/generateTrackingLink?loadId=${loadId}`, options).pipe(
      map((response) => (response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  shareTrackingLink(trackingRequest: any, link) {
    trackingRequest.messageBody = trackingRequest.messageBody.replace('#LINK','')
    if(trackingRequest.type === 'sms'){
      trackingRequest.messageBody =  trackingRequest.messageBody +' '+link
    }
    else{
      const template = `<p>${trackingRequest.messageBody} <a href='${link}'>Tracking link</a></p>`
      trackingRequest.messageBody = template;
    }
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(environment.trucksurl + `/shareTrackingInfo`, trackingRequest, options).pipe(
      map((response) => (response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getTruckLiveDash(truckId) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    let obj = {
      'deviceid': truckId,
      'datatype': 0,
      'playtype': 'flv',
      'channels': [1]
    };
    return this.http.post(environment.showLiveFootage, obj, options).pipe(
      map((response) => (response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getMediaListByTruckId(truckId: any, startTime: string, endTime: string) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    const url = `${environment.trucksurl}/${truckId}/recordings?startTime=${startTime}&endTime=${endTime}`;
    return this.http.get(url, options).pipe(
      map((response) => (response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getMediaByTruckId(deviceId: any, startTime: string, endTime: string, deviceName: string) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    const url = `${environment.trucksurl}/${deviceId}/recordings/playback?startTime=${startTime}&endTime=${endTime}&deviceName=${deviceName}`;
    return this.http.get(url, options).pipe(
      map((response) => (response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getTruckCurrentLocation(truckId: string) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    const url = `${environment.trucksurl}/${truckId}/current-location`;
    return this.http.get(url, options).pipe(
      map((response) => (response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

}
